import * as API from "../index";
import {POSTHEADER} from "../index";
//角色接口
export default {

  //获取机构
  /*iasorganizationge:params=>{
    return API.POST(idaasServiceUrl+'/ias/organization/getlist', params)
  },*/

  // 获取组织机构下人员信息
  /*curOrgUserList:params=>{
  return API.GET(idaasServiceUrl+'/ias/organization/user/list', params)
  },*/

  //获取机构数据
  iasorganizationge:params=>{
    return API.POST(SYSSERVER+'/api/v1/enterprise/dept/list', params)
  },

  // 获取组织机构下人员信息
  curOrgUserList:params=>{
    return API.POST(ACCOUNTSERVER+'/api/v1/user/list/dept', params)
  },

  /*从机构模糊查询用户*/
  searchUserFromDept:params=>{
    return API.POST(ACCOUNTSERVER+'/api/v1/user/dept/list', params)
  },

  /*查询主管*/
  queryManager:params=>{
    return API.POST(SYSSERVER+'/api/v2/usermanage/queryManager', params)
  },


  /*查询分组审批人*/
  queryGroupDetails:params=>{
    return API.POST(SYSSERVER+'/api/v2/usermanage/queryGroupDetails', params)
  },





}



// WEBPACK FOOTER //
// ./src/api/xtbg_system/api_userManage.js